import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';
import '../assets/golf-club.css'
import httpRequest from '../components/request-api'
import Rating from '@material-ui/lab/Rating';
import {
    BrowserView,
    isTablet,
  } from "react-device-detect";

class GolfClubWeb extends Component {
  constructor(props) {
    super(props);      
    this.state = {
        items : [],
        keySearch:""
    }
  } 

  componentDidMount() {
   this.fetchDataCourse(1,"")
   window.scrollTo({top: 0, behavior: 'smooth'});
  }

  fetchDataCourse = async (page, search) => {
    var newItems = [];
    await httpRequest.fetchCouse(search,page).then(result => {
        result.data.result.data.forEach((item) => {
            if(item.id !== this.props.dataForGolfClub.course_id[0])
                newItems.push(item)
        })

        this.setState({
            items: newItems
        })
    }).catch(error => {
        console.log(error);
    })
}

  handleSearchContact = (e) => {
    let { value } = e.target
    this.setState({
        keySearch: value,
    })
};

    search(){
        this.fetchDataCourse(1,this.state.keySearch)
    }

  render() {
    const { t, dataForGolfClub, name } = this.props;
    const { items } = this.state;
    const inCount = dataForGolfClub.hole_par_10+dataForGolfClub.hole_par_11+dataForGolfClub.hole_par_12+dataForGolfClub.hole_par_13+dataForGolfClub.hole_par_14+dataForGolfClub.hole_par_15+dataForGolfClub.hole_par_16+dataForGolfClub.hole_par_17+dataForGolfClub.hole_par_18
    const outCount = dataForGolfClub.hole_par_01+dataForGolfClub.hole_par_02+dataForGolfClub.hole_par_03+dataForGolfClub.hole_par_04+dataForGolfClub.hole_par_05+dataForGolfClub.hole_par_06+dataForGolfClub.hole_par_07+dataForGolfClub.hole_par_08+dataForGolfClub.hole_par_09
    const inDistance = dataForGolfClub.hole_yard_10+dataForGolfClub.hole_yard_11+dataForGolfClub.hole_yard_12+dataForGolfClub.hole_yard_13+dataForGolfClub.hole_yard_14+dataForGolfClub.hole_yard_15+dataForGolfClub.hole_yard_16+dataForGolfClub.hole_yard_17+dataForGolfClub.hole_yard_18
    const outDistance = dataForGolfClub.hole_yard_01+dataForGolfClub.hole_yard_02+dataForGolfClub.hole_yard_03+dataForGolfClub.hole_yard_04+dataForGolfClub.hole_yard_05+dataForGolfClub.hole_yard_06+dataForGolfClub.hole_yard_07+dataForGolfClub.hole_yard_08+dataForGolfClub.hole_yard_09
    const handleClickToGolfCourse = (id) => {
        this.props.selectId(id)
      };
    const handleClickBack = () => {
        this.props.handleClick() 
      };
    const setName = (item) => {
    if(this.props.lng === "th"){
        return `${ item.name_th !== "-"? item.name_th: item.name_en}`
        }
        else if(this.props.lng === "en"){
        return `${ item.name_en !== "-"? item.name_en: item.name_th}`
        }
    };  
    return (
    <div id="app">
         <h6 className="text-left back-title cursor" onClick={() => handleClickBack()}><span className="icon-back"><i className="ti-angle-left mr-2 icon-cente"/>{name}</span> </h6>
         <div className="container" style={{"marginBottom": "7rem"}}>
            <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8">
                <table style={{ border: "1px solid #dddddd"}}>
                <thead>
                    <tr className="blue">
                        <th>{t('hole')}</th>
                        <th>{t('par')}</th>
                        <th>{t('distance')}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>1</td>
                        <td>{dataForGolfClub.hole_par_01}</td>
                        <td>{dataForGolfClub.hole_yard_01}</td>
                    </tr>
                    <tr style={{color:"#9A9A9A"}}>
                        <td>2</td>
                        <td>{dataForGolfClub.hole_par_02}</td>
                        <td>{dataForGolfClub.hole_yard_02}</td>
                    </tr>
                    <tr>
                        <td>3</td>
                        <td>{dataForGolfClub.hole_par_03}</td>
                        <td>{dataForGolfClub.hole_yard_03}</td>
                    </tr>
                    <tr style={{color:"#9A9A9A"}}>
                        <td>4</td>
                        <td>{dataForGolfClub.hole_par_04}</td>
                        <td>{dataForGolfClub.hole_yard_04}</td>
                    </tr>
                    <tr>
                        <td>5</td>
                        <td>{dataForGolfClub.hole_par_05}</td>
                        <td>{dataForGolfClub.hole_yard_05}</td>
                    </tr>
                    <tr style={{color:"#9A9A9A"}}>
                        <td>6</td>
                        <td>{dataForGolfClub.hole_par_06}</td>
                        <td>{dataForGolfClub.hole_yard_06}</td>
                    </tr>
                    <tr>
                        <td>7</td>
                        <td>{dataForGolfClub.hole_par_07}</td>
                        <td>{dataForGolfClub.hole_yard_07}</td>
                    </tr>
                    <tr style={{color:"#9A9A9A"}}>
                        <td>8</td>
                        <td>{dataForGolfClub.hole_par_08}</td>
                        <td>{dataForGolfClub.hole_yard_08}</td>
                    </tr>
                    <tr>
                        <td>9</td>
                        <td>{dataForGolfClub.hole_par_09}</td>
                        <td>{dataForGolfClub.hole_yard_09}</td>
                    </tr>
                    <tr className="text-color">
                        <td>{t('out')}</td>
                        <td>{outCount}</td>
                        <td>{outDistance}</td>
                    </tr>
                    <tr>
                        <td>10</td>
                        <td>{dataForGolfClub.hole_par_10}</td>
                        <td>{dataForGolfClub.hole_yard_10}</td>
                    </tr>
                    <tr style={{color:"#9A9A9A"}}>
                        <td>11</td>
                        <td>{dataForGolfClub.hole_par_11}</td>
                        <td>{dataForGolfClub.hole_yard_11}</td>
                    </tr>
                    <tr>
                        <td>12</td>
                        <td>{dataForGolfClub.hole_par_12}</td>
                        <td>{dataForGolfClub.hole_yard_12}</td>
                    </tr>
                    <tr style={{color:"#9A9A9A"}}>
                        <td>13</td>
                        <td>{dataForGolfClub.hole_par_13}</td>
                        <td>{dataForGolfClub.hole_yard_13}</td>
                    </tr>
                    <tr>
                        <td>14</td>
                        <td>{dataForGolfClub.hole_par_14}</td>
                        <td>{dataForGolfClub.hole_yard_14}</td>
                    </tr>
                    <tr style={{color:"#9A9A9A"}}>
                        <td>15</td>
                        <td>{dataForGolfClub.hole_par_15}</td>
                        <td>{dataForGolfClub.hole_yard_15}</td>
                    </tr>
                    <tr>
                        <td>16</td>
                        <td>{dataForGolfClub.hole_par_16}</td>
                        <td>{dataForGolfClub.hole_yard_16}</td>
                    </tr>
                    <tr style={{color:"#9A9A9A"}}>
                        <td>17</td>
                        <td>{dataForGolfClub.hole_par_17}</td>
                        <td>{dataForGolfClub.hole_yard_17}</td>
                    </tr>
                    <tr>
                        <td>18</td>
                        <td>{dataForGolfClub.hole_par_18}</td>
                        <td>{dataForGolfClub.hole_yard_18}</td>
                    </tr>
                    <tr className="text-color">
                        <td>{t('in')}</td>
                        <td>{inCount}</td>
                        <td>{inDistance}</td>
                    </tr>
                    <tr className="total weight-text text-color">
                        <td>{t('total')}</td>
                        <td>{inCount+outCount}</td>
                        <td>{inDistance+outDistance}</td>
                    </tr>
                </tbody>
                </table>
                </div>
                { !isTablet ? 
                <div className="col-4 col-md-4">
                       <BrowserView>
                            <div className="blog_right_sidebar">
                            <aside className="single_sidebar_widget search_widget">
                                <form action="#">
                                <div className="form-group">
                                    <div className="input-group mb-3">
                                    <input type="text" className="form-control" placeholder="Search Keyword" onFocus={() => this.placeholder = ''} onBlur={() =>this.placeholder = 'Search Keyword'}  onChange={e => this.handleSearchContact(e)} />
                                    <div className="input-group-append">
                                        <button className="btns" type="button"  onClick={e => this.search()}><i className="ti-search"/></button>
                                    </div>
                                    </div>
                                </div>
        
                                </form>
                            </aside>
                            <aside className="single_sidebar_widget popular_post_widget">
                                <h3 className="widget_title">Similar golf course</h3>
                                {
                                items.map((item, index) => {
                                    return (
                                        <div className="media post_item cursor"  onClick={() => handleClickToGolfCourse(item.course_code)} key={index}>
                                        <img src={`${item.course_photo === false ? '/assets/img/default-empty-golf-field.jpg':`data:image/png;base64,${item.course_photo}`}`} style={{width: "40%"}} alt="post" />
                                        <div className="media-body text-left"> 
                                            <p className="blue">{setName(item)}</p>
                                            <Rating name="half-rating" value={item.satisfaction_score} precision={0.5} readOnly />
                                        </div>
                                        </div>
                                      );
                                    })
                                }
                            </aside>
                            </div>
                              </BrowserView>
                   
                        </div>:<></>
                         }
                </div>
        </div>
    </div>

    );
  }
}

export default withNamespaces()(GolfClubWeb);